<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("House Keeping Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div> -->

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getHouseKeepingReport()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            class="col-lg-6 col-xl-3 align-self-center mt-2 d-flex justify-content-end align-items-center"
            v-if="houseKeepingRecords.length > 0"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->
            <a href="#" title="Download as Excel" @click="excelDownload()">
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getHouseKeepingReport('Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        v-if="houseKeepingRecords.length > 0"
        style="overflow-x:scroll !important;width: auto !important"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Screen/Theatre</th>
            <th>Show Time</th>
            <th>Movie Name</th>
            <th>End Time</th>
            <th>Rate Card</th>
            <!-- <th>Capacity</th>
            <th>Occ%</th> -->
          </thead>
          <tbody>
            <template v-for="(screenData, screenIndex) in houseKeepingRecords">
              <tr :key="screenIndex + 'screenData'">
                <td :rowspan="screenData.show_arr.length + 1">{{
                  screenData.screen_name
                }}</td></tr
              >
              <tr
                v-for="(houseKeepingData,
                houseKeepingIndex) in screenData.show_arr"
                :key="screenIndex + 'HouseKeeping' + houseKeepingIndex"
              >
                <td class="text-left">{{ houseKeepingData.start_time }}</td>
                <td class="text-left">{{ houseKeepingData.movie_name }}</td>
                <td class="text-left">{{ houseKeepingData.end_time }}</td>
                <td class="text-left">{{ houseKeepingData.rc_g_name }}</td>
                <!-- <td class="text-right">
                {{ houseKeepingData.screen_total_seats }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    (houseKeepingData.booked_seats /
                      houseKeepingData.screen_total_seats) *
                      100
                  )
                }}%
              </td> -->
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div v-if="houseKeepingRecords.length == 0">
        <table class="swc-report-table">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Date</th>
            <th>Branch</th>
            <th>Show No</th>
            <th>Screen/Theatre</th>
            <th>Movie Name</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Capacity</th>
            <th>Occ%</th>
          </thead>
          <tbody>
            <tr>
              <td colspan="12">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      houseKeepingRecords: [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
  },
  mounted() {},
  methods: {
    moment,
    excelDownload() {
      let temp_data = [];
      this.houseKeepingRecords.map((x, index) => {
        x.show_arr.map((y) => {
          temp_data.push(y);
        });
      });
      let data = [
        {
          sheet: "House Keeping Report",
          columns: [
            {
              value: "screen_name",
              label: "Screen Name",
            },

            {
              value: "start_time",
              label: "Start Time",
            },
            {
              value: "movie_name",
              label: "Movie Name",
            },
            {
              value: "end_time",
              label: "End Time",
            },
            {
              value: "rc_g_name",
              label: "Rate Card",
            },
            // {
            //   value: (row) =>
            //     row.screen_total_seats ? row.screen_total_seats : "-",
            //   label: "Capacity",
            // },
            // {
            //   value: (row) =>
            //     row.booked_seats && row.screen_total_seats
            //       ? +parseFloat(
            //           parseFloat(row.booked_seats / row.screen_total_seats) *
            //             100
            //         ).toFixed(2)
            //       : "-",
            //   label: "Occupancy",
            // },
          ],
          content: temp_data,
        },
      ];
      let settings = {
        fileName: `HouseKeepingReport_${
          this.dropDown.selectedCinemaName
        }_${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    getCinemaList: function() {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getHouseKeepingReport(isPdf = "N") {
      this.houseKeepingRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.fromDate).format("YYYY-MM-DD"),
        user_name: this.secureStore.get("USINFO").username,
        isPdf,
      };
      ReportsService.GetHouseKeepingReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.houseKeepingRecords = data.Records;
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 1000);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/houseKeepingReport.vue